import { VideoEventResponse } from '$Generated/api';

// Event types that originate from camera AI detection and can have AI overlay footage.
// Excludes driver-initiated events, video recalls, and telematics-only (non-camera-AI) event types.
export const AI_OVERLAY_ELIGIBLE_EVENT_TYPE_NAMES = [
    'Pedestrian Collision Warning',
    'Driver View Obstructed',
    'Speed Limit Violation',
    'Tailgating',
    'Stop Sign Violation',
    'Yawn',
    'Lane Departure Warning',
    'Cell Phone',
    'No Seatbelt',
    'Driver Smoking',
    'Distracted Driver',
    'Driver Fatigue',
    'Forward Collision Warning',
    'Critical Speeding',
];

export const isAiOverlayEligibleEventType = (videoEvent: VideoEventResponse | undefined): boolean =>
    videoEvent?.videoEventTypePairings?.some(
        (pairing) => !!pairing.videoEventTypeString && AI_OVERLAY_ELIGIBLE_EVENT_TYPE_NAMES.includes(pairing.videoEventTypeString),
    ) ?? false;
